import { render, staticRenderFns } from "./TemplateDelete.vue?vue&type=template&id=5ec10b60"
import script from "./TemplateDelete.vue?vue&type=script&lang=js"
export * from "./TemplateDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports